export const updateCellPopulationChoice = (target) => {
  const payload = target;
  return (dispatch) => {
    dispatch({
      type: 'SET_CHOSEN',
      json: payload,
    });
  };
};
export const addCellPopulationChoice = (target) => {
  const payload = target;
  return (dispatch) => {
    dispatch({
      type: 'ADD_CHOSEN',
      json: payload,
    });
  };
};
export const removeCellPopulationChoice = (target) => {
  const payload = target;
  return (dispatch) => {
    dispatch({
      type: 'REMOVE_CHOSEN',
      json: payload,
    });
  };
};

export const updateCellPopulationOrder = (target) => {
  const payload = target;
  return (dispatch) => {
    dispatch({
      type: 'SET_ORDER',
      json: payload,
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/cell_population.js